@for (category of filteredCategories; track trackById($index, category)) {
  <div class="category-wrapper w-100">
    <div class="category-header">
      <h2 class="category-name"> {{ category.id | translate }}</h2>
      <hr>
      </div>
      <div class="row d-flex justify-content-center box-wrapper">
        @for (item of category.items; track trackById($index, item)) {
          @if (!item.indisp) {
            <ng-container
              [ngTemplateOutlet]="(enablePicture && category.detail) ? detailItem2 : minimalItem"
              [ngTemplateOutletContext]="{item, id: item.id}">
            </ng-container>
          }
        }
      </div>
      @if (category.message?.end; as message) {
        <div class="d-flex justify-content-center mt-4">
          <span> {{ message | translate }}</span>
        </div>
      }
    </div>
  }

  <ng-template #minimalItem let-item="item" let-id="id">
    <div
      [id]="id"
      class="app-card item minimal p-3 menu-card-trigger"
      [ngClass]="{'disabled': item.indisp}"
      role="button"
      tabindex="0"
      (click)="openModal(item)"
      (keydown.enter)="openModal(item)"
      (keydown.space)="openModal(item); $event.preventDefault()"
      >
      <div class="d-flex w-100">
        <span class="menu-item-name flex-grow-1 text-wrap me-2">{{ item.id | translate }}</span>
        <span class="menu-item-price flex-shrink-0 text-end"> {{ item.price | currency: 'EUR' }} </span>
      </div>
    </div>
  </ng-template>

  <ng-template #detailItem2 let-item="item" let-id="id">
    <div
      [id]="id"
      class="col-12 card-size"
      [ngClass]="{'disabled': item.indisp}"
      >
      <div
        class="app-card item detail-card menu-card-trigger"
        role="button"
        tabindex="0"
        (click)="openModal(item)"
        (keydown.enter)="openModal(item)"
        (keydown.space)="openModal(item); $event.preventDefault()"
        >
        <div class="pic-wrapper">
          <img class="picture"
            [src]="IMAGES_PATH + item.id + '.jpg'"
            (error)="onImageError($event)"
            width="200px"
            height="200px"
            />
          </div>
          <div class="item-detail">
            <div class="detail-header">
              <span class="menu-item-name">{{ item.id | translate }}</span>
              <span class="menu-item-price"> {{ item.price | currency: 'EUR' }} </span>
            </div>
            <p class="menu-item-description"> {{ (item.id + '.desc') | optTranslate }} </p>
          </div>
        </div>
      </div>
    </ng-template>

    @if (activeModalIndex >= 0) {
      <app-menu-item-modal
        [itemId]="activeModalIndex"
        [items]="modalItems"
        [defaultImagePath]="DEFAULT_IMAGE_PATH"
        (close)="closeModal()"
      ></app-menu-item-modal>
    }
